<template>
  <div class="ui padded centered grid" v-if="activeTab !== null">

    <nav-details-top></nav-details-top>
    <div class="sixteen wide column">
      <h2 class="ui big header">Patient Details for {{ patientProfilePlan.data.medgateId }}
        <br>
        <span v-if="renderCurrentCoachingDay(parseInt(patientProfilePlan.data.startDate)) > 0">
          Coaching Day {{ renderCurrentCoachingDay(parseInt(patientProfilePlan.data.startDate)) }}
        </span>
        <span v-else>
          Not yet started
        </span>
      </h2>
      <div class="ui three item secondary pointing menu">
        <a class="item"
           v-for="tab in tabList"
           :class="{ active: tab.text === activeTab.text }"
           @click="updateTab(tab)">
          {{ tab.text }}
        </a>
      </div>
    </div>

    <div class="row" v-if="activeTab.name === 'Feedback'">
      <div class="sixteen wide column" style="margin-bottom:2em;">
      <h3 class="ui header" style="margin-bottom:0;"><i class="comments icon"></i>Patient Feedback</h3>
      <h3 class="ui dividing header" style="margin-top:0;"><span class="sub header">Encourage or provide advice on how to get the most out of this coaching program.</span></h3>
      </div>

      <div class="five wide column">
        <div class="ui sub header">Previous Message</div>
        <div class="ui inverted clearing attached segment"
             style="background-color: #222a34; width:100%; border-radius: 0.5em; "
             v-if="previousCoachMessage.title !== null || previousCoachMessage.body !== null">
          <div class="ui inverted header">
            {{ previousCoachMessage.title }}
            <div class="sub header"><i class="calendar icon"></i>{{ localizedTimestamp(previousCoachMessage.lastModifiedTime) }}</div>
          </div>
          <div class="content" style="color: #ffffff; background-color: #222a34;" v-html="previousCoachMessage.body"></div>
        </div>
        <div v-else>
          No previous message.
        </div>
      </div>
      <div class="six wide column">
        <div class="ui form">
          <div class="field">
            <label>Message Title</label>
            <input type="text" v-model="patientProfilePlan.data.coachMessage.title">
          </div>

          <div class="required field">
            <label>Message Text</label>
            <quill-editor v-model="patientProfilePlan.data.coachMessage.body"></quill-editor>
          </div>
          <div class="ui primary button" @click="updateCoachMessage">
            Update Message
          </div>
        </div>
      </div>
      <div class="five wide column">
        <div class="ui sub header">New Message Mobile Preview</div>
        <div class="ui inverted clearing attached segment"
             style="background-color: #222a34; width:100%; border-radius: 0.5em; ">
          <div class="ui inverted header">
            {{ patientProfilePlan.data.coachMessage.title }}
            <div class="sub header"><i class="calendar icon"></i>{{ localizedTimestamp(new Date().getTime()) }}</div>
          </div>
          <div class="content" style="color: #ffffff" v-html="patientProfilePlan.data.coachMessage.body"></div>
        </div>

      </div>


      <div class="sixteen wide column">
        <br>
        <br>
        <patient-reports
          :patientProfilePlan="patientProfilePlan"
          :inheritedPatient="currentPatient"></patient-reports>
      </div>
    </div>

    <keep-alive>
      <div class="row" v-if="activeTab.name === 'Coaching'">
      <div class="sixteen wide column">

        <div class="ui positive message" id="update-plans-success" style="display: none;">
          <i class="green checkmark icon"></i>
          Coaching Plans updated successfully!
        </div>

        <div class="ui negative message" id="update-plans-failed" style="display: none;">
          <i class="red exclamation icon"></i>
          Coaching Plans updated successfully!
        </div>

        <h3 class="ui header" style="margin-bottom:0;">Action Plan</h3>
        <h3 class="ui dividing header" style="margin-top:0;"><span class="sub header">Assign specific actions to this patient</span>
        </h3>
          <patient-action-plan-table
            :patientId="currentPatient.userId"
            :selectedActionPlanIdList="selectedActionPlanIdList"
            :prevSelectedActionContent="prevSelectedActionContent"
            @updateNewOnlyActions="updateNewOnlyActions"
            @updateActions="updatedSelectedActionPlanIdList"
          ></patient-action-plan-table>
        <br>

        <patient-action-plan-button-dropdown
          :medgateId="patientProfilePlan.data.medgateId"
          :patientObjective="patientProfilePlan.data.objective"
          :patientNotes="patientProfilePlan.data.coachNotes"
          :selectedIdList="selectedActionPlanIdList"
          @updateActions="updatedSelectedActionPlanIdList"></patient-action-plan-button-dropdown>

        <patient-action-item-button-dropdown
          :medgateId="patientProfilePlan.data.medgateId"
          :patientObjective="patientProfilePlan.data.objective"
          :patientNotes="patientProfilePlan.data.coachNotes"
          :selectedIdList="selectedActionPlanIdList"
          @updateActions="updatedSelectedActionPlanIdList"></patient-action-item-button-dropdown>

        <br>
        <br>
        <h3 class="ui header" style="margin-bottom:0;">Lesson Plan</h3>
        <h3 class="ui dividing header" style="margin-top:0;"><span class="sub header">Assign specific actions to this patient</span>
        </h3>
        <patient-lesson-plan-table
          :selectedLessonPlanIdList="selectedLessonPlanIdList"
          :prevSelectedLessonContent="prevSelectedLessonContent"
          @updateNewOnlyLessons="updateNewOnlyLessons"
          @updateLessons="updatedSelectedLessonPlanIdList"
        ></patient-lesson-plan-table>

        <patient-lesson-plan-button-dropdown
          :medgateId="patientProfilePlan.data.medgateId"
          :patientObjective="patientProfilePlan.data.objective"
          :patientNotes="patientProfilePlan.data.coachNotes"
          :selectedIdList="selectedLessonPlanIdList"
          @updateLessons="updatedSelectedLessonPlanIdList"></patient-lesson-plan-button-dropdown>

        <patient-lesson-item-button-dropdown
          :medgateId="patientProfilePlan.data.medgateId"
          :patientObjective="patientProfilePlan.data.objective"
          :patientNotes="patientProfilePlan.data.coachNotes"
          :selectedIdList="selectedLessonPlanIdList"
          @updateLessons="updatedSelectedLessonPlanIdList"></patient-lesson-item-button-dropdown>



        <br>
        <br>
        <br>

        <div class="ui left floated big primary button" @click.prevent="addNewCoachingPlans"
             :class="{ disabled: loadingState}">
          <span v-if="loadingState === false"><i class="save icon"></i> Update Coaching Plans</span>
          <span v-if="loadingState === true">Updating Coaching Plans&nbsp;&nbsp;<i class="ui loading spinner icon"></i></span>
        </div>
      </div>
    </div>
    </keep-alive>

    <div class="row" v-if="activeTab.name === 'Profile'">
      <div class="eight wide column">

        <h3 class="ui header" style="margin-bottom:0;"><i class="user icon"></i>Patient Profile</h3>
        <h3 class="ui dividing header" style="margin-top:0;"></h3>

        <patient-profile-edit
          :inheritedPatient="patientProfilePlan"
          :userId="currentPatient.userId"
          :consent="currentPatient.consent"
          @refetchPatientData="getCurrentPatientData">
        </patient-profile-edit>

      </div>
    </div>

  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import NavDetailsTop from '../NavDetailsTop.vue'
  import PatientReports from './PatientReports.vue'
  import PatientProfileEdit from './PatientProfileEdit.vue'
  import PatientActionPlanTable from './PatientActionPlanTable.vue'
  import PatientLessonPlanTable from './PatientLessonPlanTable.vue'
  import PatientActionPlanButtonDropdown from './PatientActionPlanButtonDropdown.vue'
  import PatientActionItemButtonDropdown from './PatientActionItemButtonDropdown.vue'

  import PatientLessonItemButtonDropdown from './PatientLessonItemButtonDropdown.vue'
  import PatientLessonPlanButtonDropdown from './PatientLessonPlanButtonDropdown.vue'
  import {quillEditor} from 'vue-quill-editor'
  import dataStructure from '../../validation/dataStructure'

  export default {
    props: {
      patientid: {
        default: function(){
          return this.$route.params.patientid
        }
      },
      tabId: {
        type: Number,
        required: false,
        default: function(){
          return 0
        }
      }
    },
    components: {
      quillEditor,
      NavDetailsTop,
      PatientProfileEdit,
      PatientActionPlanButtonDropdown,
      PatientActionItemButtonDropdown,
      PatientLessonItemButtonDropdown,
      PatientLessonPlanButtonDropdown,
      PatientLessonPlanTable,
      PatientActionPlanTable,
      PatientReports
    },
    data() {
      return {
        activeTab: null,
        tabList: [
          {
            name: 'Feedback',
            text: 'Patient Feedback & Monitoring'
          },
          {
            name: 'Coaching',
            text: 'Coaching Plans'
          },
          {
            name: 'Profile',
            text: 'Patient Profile'
          },
        ],
        currentTimestamp: new Date().getTime(),
        currentPatient: JSON.parse(JSON.stringify(dataStructure.patientStructure)),
        patientProfilePlan: JSON.parse(JSON.stringify(dataStructure.profilePlanStructure)),
        previousCoachMessage: {
          title: null,
          body: null,
          lastModifiedTime: null
        },
        prevSelectedLessonPlanIdList: [],
        prevSelectedActionPlanIdList: [],
        selectedLessonPlanIdList: [],
        selectedActionPlanIdList: [], //Array of numbers!!! ,
        prevSelectedActionContent : [],
        prevSelectedLessonContent : [],
        newOnlyLessonContent: [],
        newOnlyActionContent: [],
        loadingState: false
      }
    },
    computed: {
      ...mapState(['userAuthToken', 'coachingLessonPlansAll', 'coachingActionPlansAll', 'coachingLessonsAll', 'coachingActionsAll', 'patientsAllOverview']),

    },
    methods: {
      updateCoachMessage: function(){
        this.patientProfilePlan.data.coachMessage.lastModifiedTime = this.convertLocaltoUTCTimeStamp(new Date().getTime());

        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programUsers/' + this.currentPatient.userId + '/userPlans';

        //Note: passes in the entire patientProfilePlan because the profile section of it does not interact with the data on the coaching tab :)
        this.$http.put(requestUrl, [this.patientProfilePlan]).then( (response) => {

          window.location.reload(true);
          //FIXME: check with Zeeshan if the help is under failedPlans or I will get an help message
        }, (error) => {
          Rollbar.error("help in updating coaching message for patientId: " + this.patientid, error)
        });
      },
      addNewCoachingPlans: function() {
        // This function handles the addition of new action plans:
        // First, POST to userPlans
        // Then, PUT the PatientProfilePlan

        // TODO: Add a toggle for loadingState
        this.loadingState = true;
        this.updatePatientCoachingPlans().then((response) => {
          this.updatePatientProfilePlan().then((response) => {
            window.location.reload(true);
          })
        });
      },
      updatePatientProfilePlan: function(){

        return new Promise((resolve, reject) => {
          let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programUsers/' + this.currentPatient.userId + '/userPlans';

          this.updatePatientActionTracking().then(()=>{

            this.$http.put(requestUrl, [this.patientProfilePlan]).then( (response) => {
              let numErrors = response.body.result.failedPlans.length;
              if (numErrors !== 0){
                Rollbar.error(numErrors + "plan(s) for Program Patient ID: " + this.patientid, response.body.result.failedPlans);
              }
              resolve();
            }, (error) => {
              Rollbar.error("help in updating planType profile for programPatientId: " + this.patientid, error);
              //FIXME: Maybe add an alert to force coaches to know?
              reject();
            });
          });
        });
      },
      updatePatientCoachingPlans: function(){
        return new Promise((resolve, reject) => {
          let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programUsers/' + this.currentPatient.userId + '/userPlans';

          this.$http.post(requestUrl, this.constructPatientUserPlans()).then( (response) => {
            let numErrors = response.body.result.failedPlans.length;
            if (numErrors !== 0){
              Rollbar.error(numErrors + "plan(s) for Program Patient ID: " + this.patientid, response.body.result.failedPlans);
            }
            resolve();
          }, (error) => {
            Rollbar.error("help in updating data for programPatientId: " + this.patientid, error);
            alert("Sorry! Something seems to have gone wrong. Please refresh the page and try again.");
            reject();
          });
        });


      },
      //constructs plans with userplans & reminders
      constructPatientUserPlans: function() {
        //Note: this.newOnlyActionContent && newOnlyLessonContent is associated with the store content and thus the ugly JSON.parse
        let userPlansAll = JSON.parse(JSON.stringify(this.newOnlyActionContent.concat(this.newOnlyLessonContent)));

        //Based on start day of patient, create all the days that this patients need to track for this action plan
        let coachingLocalStart = new Date($('#coaching-start-date').val()).getTime();
        let coachingUTCStart = this.convertLocaltoUTCTimeStamp(coachingLocalStart);

        let userPlansWithId = userPlansAll.map(function(element) {
          element.data.id = element.id;
          delete element.id;

          // converts integer start and end day into a timestamp
          element.data.options.startTimestamp = coachingUTCStart + (86400000 * (parseInt(element.data.options.startDay) - 1));

          if (element.planType === 'action') {
            element.data.options.endTimestamp =  coachingUTCStart + (86400000 * (parseInt(element.data.options.endDay) - 1));

            // init reminders property so that patient can just make a single PUT call
            // copying the relevant parts of element.data.reminder over so can update the reminder object
            element.reminders = [{
              title: element.data.options.reminder.title,
              body: element.data.options.reminder.body,
              data: {
                notification: {
                  buddyId: process.env.BUDDY_BOT_ID,
                  timestamps: []
                },
                isDaily: element.data.options.reminder.isDaily,
                alarmDate: null,  // Not rendered in backoffice
                alarmTime: null, //Not rendered in backoffice
              }
            }];
          }
          return element
        });

        return userPlansWithId;
      },
      //similiar to the constructPatientActionTracking on PagePatientCreate except this pushes instead of overrides the new content
      updatePatientActionTracking: function(){
        return new Promise((resolve, reject) => {
          let coachingUTCStart = parseInt(this.patientProfilePlan.data.startDate);

          this.newOnlyActionContent.forEach((element)=>{
            //practicing paranoia
            if (element.data.options.userTracking.status.toString() === 'true') {
              if (element.data.options.userTracking.isDaily.toString() === 'true') {

                this.patientProfilePlan.data.dailyTracking.push({
                  id: element.id,
                  trackingStatus: []
                });

                let currentDailyTrackingIndex = this.patientProfilePlan.data.dailyTracking.length -1;
                for (let i = 0; i < (parseInt(element.data.options.endDay) - parseInt(element.data.options.startDay) + 1); i++){
                  this.patientProfilePlan.data.dailyTracking[currentDailyTrackingIndex].trackingStatus.push({
                    startTimestamp: coachingUTCStart + (86400000 * (i + parseInt(element.data.options.startDay) - 1)),
                    endTimestamp: coachingUTCStart + (86400000 * (i + parseInt(element.data.options.startDay) - 1)),
                    completionStatus: null });
                }
              }
              else if (element.data.options.userTracking.isDaily.toString() === 'false') {
                this.patientProfilePlan.data.oneTimeTracking.push({
                  id: element.id,
                  trackingStatus: [{
                    startTimestamp: coachingUTCStart + (86400000 * (parseInt(element.data.options.startDay) - 1)),
                    endTimestamp: coachingUTCStart + (86400000 * (parseInt(element.data.options.endDay) - 1)),
                    completionStatus: null}],
                });
              }
              else {
                Rollbar.error("Program Plan Id: " + element.id + "has illegal syntax");
              }
            }
            else {
              this.patientProfilePlan.data.notTrackable.push({
                id: element.id,
                trackingStatus: [{ startTimestamp: coachingUTCStart + (86400000 * (parseInt(element.data.options.startDay) - 1)), endTimestamp: coachingUTCStart + (86400000 * (parseInt(element.data.options.endDay) - 1)) } ]
              });
            }
          });
          resolve();
        })

      },
      updateNewOnlyLessons: function(payload){
        this.newOnlyLessonContent = payload;
      },
      updateNewOnlyActions: function(payload){
        this.newOnlyActionContent = payload;
      },
      getCurrentPatientData: function(){
        return new Promise((resolve, reject) => {
          let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programUsersByProgramUserId/' + this.patientid;

          this.$http.get(requestUrl).then((response) => {
            let currentPatient = JSON.parse(JSON.stringify(response.body.result));
            let patientProfilePlan = currentPatient.userPlans.find(userPlan => userPlan.planType === 'profile');

            this.currentPatient = Object.assign(this.currentPatient, currentPatient);
            this.patientProfilePlan = Object.assign(this.patientProfilePlan, patientProfilePlan);

            this.currentPatient.userPlans.forEach((element)=> {
              if (element.planType === 'action' && element.data.hasOwnProperty('id')){
                this.selectedActionPlanIdList.push(element.data.id);
                this.prevSelectedActionPlanIdList.push(element.data.id);
                this.prevSelectedActionContent.push(element);
              }
              else if (element.planType === 'lesson' && element.data.hasOwnProperty('id')){
                this.selectedLessonPlanIdList.push(element.data.id);
                this.prevSelectedLessonPlanIdList.push(element.data.id);
                this.prevSelectedLessonContent.push(element);
              }
            });

            resolve();
          });
        })
      },
      updateTab(tab){
        this.activeTab = tab;
        $('.ui.accordion').accordion();
      },
      updatedSelectedActionPlanIdList: function(newIdList){
        this.selectedActionPlanIdList = newIdList;
      },
      updatedSelectedLessonPlanIdList: function(newIdList){
        this.selectedLessonPlanIdList = newIdList;
      },
      renderCurrentCoachingDay: function(timestamp){
        return Math.floor((this.currentTimestamp - timestamp) / 86400000) + 1
      }
    },
    watch: {
      activeTab: function() {
        window.requestAnimationFrame(()=>{
          $('.ui.accordion').accordion({
            exclusive: false
          });
        })
      },
      patientid: function() {
        window.location.reload(true);
      }
    },
    created(){

    },
    mounted(){

      //Fetches patient detail on mount
      this.getCurrentPatientData().then(()=> {
        this.activeTab = this.tabList[this.tabId];
      });


    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/patients/PagePatientDetails.vue